<template>
  <el-popover
    v-model:visible="state.visible"
    :visible-arrow="false"
    :teleported="false"
    trigger="click"
    placement="bottom"
    width="248"
  >
    <div class="content">
      <div class="sub-title">{{ $t('home.lang') }}</div>
      <div class="btn-list">
        <el-button
          v-for="lang in langList"
          :key="lang.value"
          class="btn"
          :class="{ active: lang.value === state.lang }"
          @click="changeLang(lang.value)"
        >
          {{ lang.label }}
        </el-button>
      </div>
      <div class="sub-title">{{ $t('home.currency') }}</div>
      <div class="btn-list">
        <el-button
          v-for="currency in state.currencyList"
          :key="currency.value"
          class="btn"
          :class="{ active: currency.value === state.currency }"
          @click="changeCurrency(currency.value)"
        >
          {{ currency.label }}
        </el-button>
      </div>

      <el-button class="confirm-btn" type="primary" @click="changeLangAndCurrency">OK</el-button>
    </div>
    <template #reference>
      <div class="lang-block">
        <span class="iconfont icon-diqiu"></span>
        <span class="lang-change">{{ state.langText }} / {{ state.currencyText }}</span>
      </div>
    </template>
  </el-popover>
</template>

<script setup>
import { langList } from '@/config/constant'
import { useUserStore } from '@/stores'
import { reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
const userStore = useUserStore()
const $route = useRoute()
const { locale } = useI18n()

const state = reactive({
  currencyList: [
    {
      label: 'USD',
      value: 'USD',
    },
    {
      label: 'EUR',
      value: 'EUR',
    },
    {
      label: 'PLN',
      value: 'PLN',
    },
    {
      label: 'CNY',
      value: 'CNY',
    },
    {
      label: 'SGD',
      value: 'SGD',
    },
    {
      label: 'GBP',
      value: 'GBP',
    },
    {
      label: 'CAD',
      value: 'CAD',
    },
    {
      label: 'AUD',
      value: 'AUD',
    },
    {
      label: 'DKK',
      value: 'DKK',
    },
  ],
  visible: false,
  lang: userStore.language,
  langText: langList.find((item) => item.value === userStore.language)?.label,
  currency: userStore.currency || 'CNY',
  currencyText: userStore.currency || 'CNY',
})
const oldLang = userStore.language
// 更改语言
const changeLang = (lang) => {
  state.lang = lang
}
// 更改币种
const changeCurrency = (currency) => {
  state.currency = currency
}

const changeLangAndCurrency = async () => {
  if (state.lang === userStore.language && state.currency === userStore.currency) {
    state.visible = false
    return
  }
  try {
    await userStore.setSelectLangAndCurrency(state.lang, state.currency)
    await userStore.setSelectCurrencyRate(state.currency)
    state.langText = langList.find((item) => item.value === state.lang)?.label
    state.currencyText = state.currency
    locale.value = state.lang
    // 不需要刷新页面
    if (['login'].includes($route.name)) return
    oldLang !== userStore.language && window.location.reload()
  } catch (error) {
    //
  } finally {
    state.visible = false
  }
}
</script>

<style lang="scss" scoped>
.lang-block {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 838px;
  // margin-right: 32px;
  padding: 0 16px;
  cursor: pointer;
  height: 40px;

  .icon-diqiu {
    font-size: 22px;
    color: var(--black-color-9);
  }

  .lang-change {
    font-size: 16px;
    color: var(--black-color-9);
    font-family: Montserrat;
    margin-left: 10px;
    display: block;
  }

  &:hover {
    background-color: var(--line-light-gray-color);
  }
}

.content {
  width: 208px;

  margin: auto;

  .sub-title {
    font-family: Montserrat;
    font-size: 16px;
    margin-top: 24px;
    color: var(--black-common-color-6);
  }

  .btn-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .btn {
      width: 96px;
      height: 36px;
      border-radius: 4px;
      margin-top: 16px;

      &.active {
        border-color: var(--primary-color);
        color: var(--primary-color);
      }
    }

    ::v-deep(.el-button) {
      margin-left: 0;
    }
  }

  .confirm-btn {
    width: 208px;
    height: 36px;
    border-radius: 8px;
    font-family: Montserrat;
    font-size: 14px;
    text-align: center;
    line-height: 36px;
    margin-top: 40px;
  }
}
</style>
